'use client';
import styled, { css } from 'styled-components';
import { resetButton } from '../../mixins/resetButton.js';

const Clickable = styled.button.attrs(({
  type = 'button'
}) => ({
  type
})).withConfig({
  componentId: "sc-qmt3ox-0"
})(["", " &[disabled]{cursor:default;}", ""], resetButton, ({
  isBlock
}) => isBlock && css(["width:100%;"]));

export { Clickable };
//# sourceMappingURL=Clickable.js.map
